import {useFetch} from "../useFetch";
import {TypeWastes} from "../../types/api/guide/typeWastes.types";
import {typeWastesService} from "../../services/guide/typeWastes-service";

export const useFetchAllTypeWastes = () => {
    const { isLoading, error, data, refetch } = useFetch<TypeWastes[]>(typeWastesService.getAll);

    return { data: data || [], isLoading, error, refetch };
}
